import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/action/delete-lines-red.svg'


const _hoisted_1 = {
  key: 0,
  class: "content mb-4 p-4"
}
const _hoisted_2 = { class: "grid grid-cols-6 gap-8" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "col-span-4 border border-solid border-[#67748E] rounded-xl p-4" }
const _hoisted_11 = { class: "flex gap-4 mb-3" }
const _hoisted_12 = { class: "flex items-center gap-4 w-full md:w-1/2" }
const _hoisted_13 = { class: "icon-number float-right" }
const _hoisted_14 = { class: "icon_item" }
const _hoisted_15 = { class: "icon_circle" }
const _hoisted_16 = { class: "icon_number" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = {
  key: 0,
  for: "requirement",
  class: "label-text"
}
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "flex items-end gap-4 w-full md:w-1/2" }
const _hoisted_21 = { class: "w-full" }
const _hoisted_22 = {
  key: 0,
  for: "dataValue",
  class: "label-text required"
}
const _hoisted_23 = { class: "invalid-feedback" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "mt-40px" }
const _hoisted_27 = { class: "border-grey-3 rounded-xl p-4" }
const _hoisted_28 = { class: "flex gap-4 mb-3" }
const _hoisted_29 = { class: "flex items-center gap-4 w-full md:w-1/2" }
const _hoisted_30 = { class: "icon-number float-right" }
const _hoisted_31 = { class: "icon_item" }
const _hoisted_32 = { class: "icon_circle" }
const _hoisted_33 = { class: "icon_number" }
const _hoisted_34 = { class: "w-full" }
const _hoisted_35 = {
  key: 0,
  for: "documentType",
  class: "label-text"
}
const _hoisted_36 = { class: "invalid-feedback" }
const _hoisted_37 = { class: "flex items-end gap-4 w-full md:w-1/2" }
const _hoisted_38 = { class: "w-full" }
const _hoisted_39 = {
  key: 0,
  for: "isRequired",
  class: "label-text"
}
const _hoisted_40 = { class: "invalid-feedback" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "flex mt-40px justify-end" }

import Card from 'primevue/card'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import * as Yup from 'yup'
import { Form, Field, useForm, FieldArray } from 'vee-validate'
import { computed, getCurrentInstance, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useRoute, useRouter } from 'vue-router'
import { isNull } from 'lodash'

const moduleStore = 'hjpTable'
const documentTypeEndpoint = 'talent/v1/documentTypes'
const positionEndpoint = 'talent/v1/positions'
const requirementEndpoint = 'talent/v1/requirements'

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const title = ref('')
const store = useStore()
const route = useRoute()
const router = useRouter()
const dataForm = ref()
const idPrams = ref(null) as any
const isLoading = ref(true)
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const defaultRequirementObj = ref({ reqData: null, dataValue: null })
const defaultDocumentTypeObj = ref({ docData: null, isRequired: false })

const toast = (status: string, toastTitle: string, message: string) => {
  $toast.add({
    severity: status,
    summary: toastTitle,
    detail: message,
    group: 'bc',
    closable: false,
    life: 3000
  })
}

const initialValues = {
  PositionName: '',
  CodePosition: '',
  Description: '',
  Requirements: [],
  DocumentTypes: [],
}

const documentStatusOptions = ref([
  { label: 'Wajib', value: true },
  { label: 'Tidak Wajib', value: false },
])

const schema = Yup.object().shape({
  PositionName: Yup.string()
    .required('Nama Divisi tidak boleh kosong')
    .min(3, 'Nama Divisi minimal 3 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Divisi tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.nameJustAlphabetAndSpace, 'Nama Lengkap hanya boleh menggunakan huruf dan spasi')
    .max(100, 'Nama Divisi tidak boleh melebihi 100 karakter')
    .test('unique-name', 'Nama Divisi sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${positionEndpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.data.filter((x: any) => x.name === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.PositionName
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  CodePosition: Yup.string()
    .required('Kode Divisi tidak boleh kosong')
    .matches(rgxExp.notSpaceChar, 'Kode Divisi tidak boleh menggunakan spasi')
    .min(1, 'Kode Divisi minimal 1 karakter')
    .max(3, 'Kode Divisi tidak boleh melebihi 3 karakter')
    .test('unique-code', 'Nama Divisi sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${positionEndpoint}${returnUrlPrams({
          search: val,
          filterField: ['code']
        })}`)
        const filterResult = res.result.data.filter((x: any) => x.code === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.CodePosition
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Description: Yup.string()
    .required('Deskripsi tidak boleh kosong')
    .max(255, 'Deskripsi tidak boleh melebihi 255 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Divisi tidak boleh hanya menggunakan spasi'),
  Requirements: Yup.array().of(
    Yup.object().shape({
      dataValue: Yup.string()
        .nullable()
        .when('reqData', ([reqData], fieldSchema) => (
          reqData !== null && reqData !== undefined
            ? fieldSchema.required('Nilai tidak boleh kosong')
            : fieldSchema.notRequired()
        ))
    })
  )
  // DataValue: Yup.string()
  //   .required('Nilai tidak boleh kosong')
  //   .min(1, 'Nilai minimal 1 karakter'),
  // .matches(rgxExp.phoneNumber, 'Masukkan Nomor Telepon valid dan harus diawali angka 0.'),
  // .test('unique-phonenumber', 'Nomor Telepon sudah digunakan', async (val) => {
  //   if (!val) return true
  //   try {
  //     const res = await apiUseCase.get(`${employeeEndpoint}${returnUrlPrams({
  //       search: val,
  //       filterField: ['phoneNumber']
  //     })}`)
  //     const filterResult = res.result.filter((x: any) => x.PhoneNumber === val)
  //     if (idPrams.value) {
  //       return filterResult.length === 0 || val === initialValues.PhoneNumber
  //     } return filterResult.length === 0
  //   } catch (error) {
  //     return false
  //   }
  // }),
  // Requirement: Yup.object()
  //   .required('Persyaratan tidak boleh kosong'),
  // DocumentType: Yup.object()
  //   .required('Tipe Dokumen tidak boleh kosong'),
  // DocumentStatus: Yup.object()
  //   .required('Status Dokumen tidak boleh kosong'),
})

const onBack = () => {
  router.push({
    name: 'master-position'
  })
}

const processSubmit = async () => {
  store.dispatch('showLoading')
  await apiUseCase.postOrPut(positionEndpoint, idPrams.value?.id, dataForm.value).then((response) => {
    const { error, result, message } = response
    if (!error) {
      console.log('positionId', result)
      if (idPrams.value?.id) {
        toast('success', 'Divisi berhasil diubah', 'Data Divisi di sistem berhasil diperbaruhi')
      } else {
        toast('success', 'Divisi berhasil ditambahkan', 'Data Divisi berhasil ditambahkan ke dalam sistem')
      }
      onBack()
    } else {
      toast('error', `Divisi gagal ${idPrams.value?.id ? 'diubah' : 'ditambahkan'}`, message)
    }
  })
  store.dispatch('hideLoading')
}

const prepareDataForm = (val: any) => {
  dataForm.value = {
    name: val.PositionName,
    code: val.CodePosition,
    description: val.Description,
    requirements: val.Requirements.map((data: any) => ({
      requirementId: data.reqData.value,
      dataValue: data.dataValue,
      description: '-'
    })),
    documentRequirements: val.DocumentTypes.map((data: any) => ({
      documentTypeId: data.docData.value,
      isRequired: data.isRequired,
      notes: '-'
    }))
  }
  if (idPrams.value) { // create new
    dataForm.value.id = idPrams.value.id
  }
  console.log('dataForm', dataForm.value)
  processSubmit()
}

const onSubmit = (value: any) => {
  prepareDataForm(value)
  console.log('submit', value)
}

// const getSinglePosition = async () => {
//   store.dispatch('showLoading')
//   console.log('getSingle', positionId)
//   await apiUseCase.get(`${positionEndpoint}/${positionId.value.id}`).then((response) => {
//     const { error, result } = response
//     if (!error) {
//       // values.value = result
//       //   requirementFilter.totalRecords = result.length
//       //   requirementList.value = result
//     }
//   })
//   store.dispatch('hideLoading')
// }

const getPositionRequirementData = async () => {
  store.dispatch('showLoading')
  const filters = {
    pageNumber: 1,
    pageSize: 20
  }
  await apiUseCase.get(`${positionEndpoint}/${idPrams.value.id}/Requirements${returnUrlPrams(filters)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      console.log('resPosReqData', result)
      initialValues.Requirements = result.map((data: any) => ({
        reqData: {
          label: data.requirementName,
          value: data.requirementId
        },
        dataValue: data.dataValue
      }))
    }
  })
  store.dispatch('hideLoading')
}

const getPositionDocumentData = async () => {
  store.dispatch('showLoading')
  const filters = {
    pageNumber: 1,
    pageSize: 20
  }
  await apiUseCase.get(`${positionEndpoint}/${idPrams.value.id}/documentRequirements${returnUrlPrams(filters)}`).then((response) => {
    const { error, result } = response
    if (!error) {
      console.log('resPosDocData', result)
      initialValues.DocumentTypes = result.map((data: any) => ({
        docData: {
          ...data,
          label: data.documentTypeName,
          value: data.documentTypeId
        },
        isRequired: data.isRequired
      }))
    }
  })
  store.dispatch('hideLoading')
}

const getPositionData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${positionEndpoint}/${idPrams.value.id}`).then((response) => {
    const { error, result } = response
    if (!error) {
      console.log('resPosData', result)
      initialValues.PositionName = result.name
      initialValues.CodePosition = result.code
      initialValues.Description = result.description
    }
  })
  store.dispatch('hideLoading')
}

const getData = async () => {
  console.log('assad')
  await getPositionData()
  await getPositionRequirementData()
  await getPositionDocumentData()
  isLoading.value = false
}

const moduleValidationSchemes = ref({})
const moduleValidationInputs = ref({})

const newSchema = Yup.lazy((value) => {
  const shapes = {}
  const DATA_OBJ_KEYS = Object.keys(value)
  console.log('newSchema', value)
  console.log('DATA_OBJ_KEYS', DATA_OBJ_KEYS)

  DATA_OBJ_KEYS.forEach(((parameter) => {
    console.log('parameter', parameter)
    if (parameter.includes('DD')) {
      // shapes[parameter] = Yup.object().required('WAJIB DIPILIH')
    } else {
      // shapes[parameter] = Yup.string().required('Campo Obrigatório')
    }
  }))

  return Yup.object().shape(shapes)
})

const defineBreadcrumb = () => {
  if (idPrams.value) {
    title.value = `Edit Divisi ${idPrams.value.name}`
  } else {
    title.value = 'Tambah Divisi'
  }
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Divisi',
      routeName: 'master-position'
    },
    {
      title: 'Daftar Divisi',
      routeName: 'master-position'
    },
    {
      title: title.value,
      routeName: 'master-position-form'
    },
  ])
}

onMounted(() => {
  console.log('dataId', route.params.id)
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    defineBreadcrumb()
    getData()
  } else {
    defineBreadcrumb()
    isLoading.value = false
  }
  // getData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      content: _withCtx(() => [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "font-bold text-xl mb-4" }, "Persyaratan Umum", -1)),
              _createVNode(_unref(Form), {
                onSubmit: onSubmit,
                "initial-values": initialValues,
                "validation-schema": _unref(schema),
                class: "form-container"
              }, {
                default: _withCtx(({ errors, setFieldValue, values, meta }) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[1] || (_cache[1] = _createElementVNode("label", {
                          for: "positionName",
                          class: "label-text required"
                        }, "Nama Divisi", -1)),
                        _createVNode(_unref(Field), { name: `PositionName` }, {
                          default: _withCtx(({ handleChange, handleBlur, field }) => [
                            _createVNode(_unref(InputText), _mergeProps({ id: "positionName" }, field, {
                              "aria-describedby": "positionName-help",
                              class: `input-primary ${errors.PositionName ? 'input-invalid' : ''}`,
                              placeholder: "Masukkan Nama Divisi",
                              onChange: handleChange,
                              onBlur: handleBlur
                            }), null, 16, ["class", "onChange", "onBlur"])
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(errors.PositionName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[2] || (_cache[2] = _createElementVNode("label", {
                          for: "codePosition",
                          class: "label-text required"
                        }, "Kode Divisi", -1)),
                        _createVNode(_unref(Field), { name: `CodePosition` }, {
                          default: _withCtx(({ handleChange, handleBlur, field }) => [
                            _createVNode(_unref(InputText), _mergeProps({ id: "codePosition" }, field, {
                              "aria-describedby": "codePosition-help",
                              class: `input-primary ${errors.CodePosition ? 'input-invalid' : ''}`,
                              placeholder: "Maksimum 3 karakter",
                              onChange: handleChange,
                              onBlur: handleBlur,
                              maxlength: "3"
                            }), null, 16, ["class", "onChange", "onBlur"])
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(errors.CodePosition), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _cache[3] || (_cache[3] = _createElementVNode("label", {
                          for: "description",
                          class: "label-text"
                        }, "Keterangan", -1)),
                        _createVNode(_unref(Field), {
                          id: "description",
                          name: "Description",
                          as: "textarea",
                          type: "text",
                          placeholder: "Tulis Keterangan",
                          class: "input-primary",
                          modelValue: values.Description,
                          "onUpdate:modelValue": ($event: any) => ((values.Description) = $event),
                          validateOnInput: true,
                          rows: "5"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(errors.Description), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "font-bold text-base mb-4 ml-8" }, "Daftar Persyaratan", -1)),
                      _createVNode(_unref(FieldArray), { name: "Requirements" }, {
                        default: _withCtx(({ fields, push, remove }) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "mb-20px",
                              key: i
                            }, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("ul", _hoisted_13, [
                                      _createElementVNode("li", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("p", _hoisted_16, _toDisplayString(i + 1), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    (i === 0)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_18, "Persyaratan"))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(Field), {
                                      id: `requirement-${i}`,
                                      name: `Requirements[${i}].reqData`
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(SelectFetch, {
                                          modelValue: values.Requirements[i].reqData,
                                          "onUpdate:modelValue": [($event: any) => ((values.Requirements[i].reqData) = $event), (val) => setFieldValue(`Requirements[${i}].reqData`, val)],
                                          inputId: `requirement-${i}`,
                                          endpoint: requirementEndpoint,
                                          fieldLabel: (v) => `${v.name}`,
                                          fieldValue: 'id',
                                          clearable: false,
                                          searchFields: ['name'],
                                          placeholder: `Pilih Persyaratan`,
                                          classname: 'custom-select'
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "fieldLabel"])
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "name"]),
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(errors.Requirements), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    (i === 0)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_22, "Nilai"))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(Field), {
                                      name: `Requirements[${i}].dataValue`
                                    }, {
                                      default: _withCtx(({ field }) => [
                                        _createVNode(_unref(InputText), {
                                          class: "",
                                          "v-bind": field.value,
                                          modelValue: field.value,
                                          "aria-describedby": "dataValue-help",
                                          placeholder: "Contoh: 65",
                                          "onUpdate:modelValue": (val) => setFieldValue(`Requirements[${i}].dataValue`, val),
                                          minlength: 10,
                                          maxlength: 14
                                        }, null, 8, ["v-bind", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1032, ["name"]),
                                    _createElementVNode("div", _hoisted_23, _toDisplayString(errors[`Requirements[${i}].dataValue`]), 1)
                                  ]),
                                  (values.Requirements.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "rounded-lg p-3 background-light-pink cursor-pointer",
                                        onClick: ($event: any) => (remove(i))
                                      }, _cache[4] || (_cache[4] = [
                                        _createElementVNode("img", {
                                          src: _imports_0,
                                          alt: "X"
                                        }, null, -1)
                                      ]), 8, _hoisted_24))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", {
                            class: "flex justify-center cursor-pointer w-fit mx-auto",
                            onClick: ($event: any) => (push(defaultRequirementObj.value))
                          }, _cache[5] || (_cache[5] = [
                            _createElementVNode("span", { class: "pi pi-plus mr-2 text-sm text-primary font-bold" }, null, -1),
                            _createElementVNode("div", { class: "text-sm text-primary font-bold" }, "Persyaratan", -1)
                          ]), 8, _hoisted_25)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "font-bold text-base mb-4" }, "Dokumen yang Dibutuhkan", -1)),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_unref(FieldArray), { name: "DocumentTypes" }, {
                        default: _withCtx(({ fields, push, remove }) => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (items, x) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "mb-20px",
                              key: x
                            }, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("ul", _hoisted_30, [
                                      _createElementVNode("li", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("p", _hoisted_33, _toDisplayString(x + 1), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    (x === 0)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_35, "Tipe Dokumen"))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(Field), {
                                      id: `DocumentTypes-${x}`,
                                      name: `DocumentTypes[${x}].docData`
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(SelectFetch, {
                                          modelValue: values.DocumentTypes[x].docData,
                                          "onUpdate:modelValue": [($event: any) => ((values.DocumentTypes[x].docData) = $event), (val) => setFieldValue(`DocumentTypes[${x}].docData`, val)],
                                          inputId: `DocumentTypes-${x}`,
                                          endpoint: documentTypeEndpoint,
                                          fieldLabel: (v) => `${v.name}`,
                                          fieldValue: 'id',
                                          clearable: false,
                                          searchFields: ['name'],
                                          placeholder: `Pilih Dokumen`,
                                          classname: 'custom-select'
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "fieldLabel"])
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "name"]),
                                    _createElementVNode("div", _hoisted_36, _toDisplayString(errors.DocumentTypes), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    (x === 0)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_39, "Status"))
                                      : _createCommentVNode("", true),
                                    _createVNode(_unref(Field), {
                                      id: "isRequired",
                                      name: `DocumentTypes[${x}].isRequired`,
                                      class: _normalizeClass(`input-primary`),
                                      validateOnInput: true
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Dropdown), {
                                          modelValue: values.DocumentTypes[x].isRequired,
                                          "onUpdate:modelValue": [($event: any) => ((values.DocumentTypes[x].isRequired) = $event), (val) => setFieldValue(`DocumentTypes[${x}].isRequired`, val)],
                                          options: documentStatusOptions.value,
                                          optionLabel: "label",
                                          optionValue: "value",
                                          placeholder: "Pilih Status Dokumen",
                                          class: "w-full md:w-14rem"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                      ]),
                                      _: 2
                                    }, 1032, ["name"]),
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(errors.DataValue), 1)
                                  ]),
                                  (values.DocumentTypes.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "rounded-lg p-3 background-light-pink cursor-pointer",
                                        onClick: ($event: any) => (remove(x))
                                      }, _cache[7] || (_cache[7] = [
                                        _createElementVNode("img", {
                                          src: _imports_0,
                                          alt: "X"
                                        }, null, -1)
                                      ]), 8, _hoisted_41))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", {
                            class: "flex justify-center cursor-pointer w-fit mx-auto",
                            onClick: ($event: any) => (push(defaultDocumentTypeObj.value))
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("span", { class: "pi pi-plus mr-2 text-sm text-primary font-bold" }, null, -1),
                            _createElementVNode("div", { class: "text-sm text-primary font-bold" }, "Tipe Dokumen", -1)
                          ]), 8, _hoisted_42)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_unref(Button), {
                      class: "btn-back mr-2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onBack()))
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("Kembali")
                      ])),
                      _: 1,
                      __: [10]
                    }),
                    _createVNode(_unref(Button), {
                      type: "submit",
                      class: "btn-primary mr-1",
                      disabled: (meta.valid && false)
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("Simpan")
                      ])),
                      _: 2,
                      __: [11]
                    }, 1032, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})